import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import { groupCandidatesByJob } from "features/dashboard/sections/weeklyActivity/metricCard/metricCandidatesModal/utils";

export const useMetricCandidates = (fetchCandidates) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const groupedByJob = groupCandidatesByJob(data);

  const fetchData = useCallback(async () => {
    try {
      const { data: responseData } = await fetchCandidates();
      setData(responseData || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [fetchCandidates]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data: groupedByJob, loading, error, count: data.length };
};
